import React from 'react';
import { Menu } from 'lucide-react';

const MobileHeader = ({ 
  darkMode, 
  mobileMenuOpen, 
  setMobileMenuOpen, 
  unreadNotifications, 
  handleTabChange,
  activeTab,
  getTabDisplayName
}) => {
  return (
    <>
      {/* Mobile Header */}
      <div className={`md:hidden fixed top-0 left-0 right-0 bg-black/95 backdrop-blur-md z-50`}>
        <div className={`border-b ${
          darkMode ? 'border-gray-600' : 'border-gray-800'
        }`}>
          <div className="flex items-center justify-between px-3 py-2">
            <div className="relative">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="p-2 text-white hover:text-gray-300"
              >
                <Menu className="w-6 h-6" />
              </button>
              {unreadNotifications > 0 && (
                <span 
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="absolute -top-1 -right-1 bg-gradient-to-r from-pink-500 to-purple-600 text-white text-xs rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center font-bold cursor-pointer">
                  {unreadNotifications > 99 ? '99+' : unreadNotifications}
                </span>
              )}
            </div>
            <div className="flex-1 flex justify-center mx-2">
              <img 
                src="/newlogo.gif" 
                alt="TopBlast" 
                className="h-12 sm:h-14 w-auto cursor-pointer"
                onClick={() => handleTabChange('home')}
              />
            </div>
            <div className="w-10"></div>
          </div>
        </div>
        {/* Mobile Tab Navigation - Fixed Logic */}
        <div className="flex items-center justify-around border-b border-gray-800">
          <button
            onClick={() => {
              // Go to the main page (not chat/leaderboard)
              const mainPage = activeTab === 'chat' || activeTab === 'leaderboard' 
                ? (localStorage.getItem('lastMainPage') || 'shit-posts')
                : activeTab;
              handleTabChange(mainPage);
            }}
            className={`flex-1 py-3 text-sm font-semibold transition-colors relative ${
              activeTab !== 'chat' && activeTab !== 'leaderboard'
                ? 'text-white' 
                : 'text-gray-500 hover:text-gray-300'
            }`}
          >
            {(() => {
              const mainPage = activeTab === 'chat' || activeTab === 'leaderboard'
                ? (localStorage.getItem('lastMainPage') || 'shit-posts')
                : activeTab;
              return getTabDisplayName(mainPage);
            })()}
            {activeTab !== 'chat' && activeTab !== 'leaderboard' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-pink-500 to-purple-600" />
            )}
          </button>
          <button
            onClick={() => handleTabChange('chat')}
            className={`flex-1 py-3 text-sm font-semibold transition-colors relative ${
              activeTab === 'chat' 
                ? 'text-white' 
                : 'text-gray-500 hover:text-gray-300'
            }`}
          >
            Live Chat
            {activeTab === 'chat' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-pink-500 to-purple-600" />
            )}
          </button>
          <button
            onClick={() => handleTabChange('leaderboard')}
            className={`flex-1 py-3 text-sm font-semibold transition-colors relative ${
              activeTab === 'leaderboard' 
                ? 'text-white' 
                : 'text-gray-500 hover:text-gray-300'
            }`}
          >
            Stats
            {activeTab === 'leaderboard' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-pink-500 to-purple-600" />
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileHeader;